export const ABCampaignStatus = {
  DRAFT: 'draft',
  RUNNING: 'running',
  COMPLETED: 'completed'
} as const

export type ABCampaignStatus = (typeof ABCampaignStatus)[keyof typeof ABCampaignStatus]

export const ABCampaignGoalMetric = {
  CTR: 'ctr',
  CVR: 'cvr'
} as const

export type ABCampaignGoalMetric = (typeof ABCampaignGoalMetric)[keyof typeof ABCampaignGoalMetric]

export const ABCampaignTargetDevice = {
  PC: 'pc',
  MOBILE: 'mobile',
  TABLET: 'tablet'
} as const

export type ABCampaignTargetDevice =
  (typeof ABCampaignTargetDevice)[keyof typeof ABCampaignTargetDevice]

export const ABCampaignSegments = {
  ALL: 'all',
  MEMBERS: 'members'
} as const

export type ABCampaignSegments = (typeof ABCampaignSegments)[keyof typeof ABCampaignSegments]

export interface ABCampaign {
  id: number
  site_id: number
  widget_id: number
  goal_metric: ABCampaignGoalMetric
  target_devices: ABCampaignTargetDevice[]
  target_segments: ABCampaignSegments[]
  status: ABCampaignStatus
  started_at: string | null
  completed_at: string | null
  min_sample_per_variant: number
  confidence_level: number
  winner_variant: string | null
  is_significant: boolean
  created_at: string
  updated_at: string
}

export interface CampaignCreate {
  widget_id: number
  goal_metric?: ABCampaignGoalMetric
  target_devices?: ABCampaignTargetDevice[] | null
  target_segments?: ABCampaignSegments[] | null
  min_sample_per_variant?: number
  confidence_level?: number
}

export interface CampaignUpdate {
  goal_metric?: ABCampaignGoalMetric | null
  target_devices?: ABCampaignTargetDevice[] | null
  target_segments?: ABCampaignSegments[] | null
  min_sample_per_variant?: number | null
  confidence_level?: number | null
}
